import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Flex, Divider, Spin, Radio } from 'antd';
import { DownFill } from 'antd-mobile-icons';
import caricon from '../../images/car-icon.svg';

import Header from './components/Header';
import InputField from './components/InputField';
import CustomPicker from './components/CustomPicker';
import ResultModal from './components/ResultModal';
import ErrorModal from './components/ErrorModal';

import { AuthValid } from 'shared/httpHandler';
import axios from 'axios';

import './booking.scss';

const BookingOther = () => {
  const navigate = useNavigate();

  useEffect(() => {
    document.title = 'LEXUS Line OA | 預約一般維修';
  }, []);

  const [token, setToken] = useState('');
  const [lineId, setLineId] = useState('');
  const [carNo, setCarNo] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [allowConfirmError, setAllowConfirmError] = useState(false);
  const [maintenanceType, setMaintenanceType] = useState('general');
  const tokenExpiredMessage = (
    <>
      <b>此頁面已失效</b>
      <br />
      請關閉目前頁面並重新點選
      <br />
      <b>車主專區 > 預約服務</b>
    </>
  );
  const fetchFailedMessage = <>伺服器忙線中, 請稍後再試</>;

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token');
    const type = queryParams.get('type');
    setMaintenanceType(type || 'general');

    if (type === 'spray') {
      setFormData((prev) => ({
        ...prev,
        bookingTitle: '預約板噴服務',
      }));
      document.title = 'LEXUS Line OA | 預約板噴服務';
    }

    if (token) {
      try {
        const payload = AuthValid.parseJwt(token);
        setToken(token);
        setLineId(payload.sub);
        setCarNo(payload.carNo);
      } catch (error) {
        console.error('Failed to parse JWT token:', error);
        setIsError(true);
        setErrorMessage(tokenExpiredMessage);
      }
    } else {
      navigate('/Error404');
    }
  }, []);

  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    region: '',
    serviceType: '',
    repairType: '其他維修',
    bookingTitle: maintenanceType === 'spray' ? '預約板噴服務' : '',
    description: '',
  });

  const [errors, setErrors] = useState({});
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const [modalType, setModalType] = useState('');
  const [isResultModalVisible, setIsResultModalVisible] = useState(false);

  const [regionPickerVisible, setRegionPickerVisible] = useState(false);
  const [servicePickerVisible, setServicePickerVisible] = useState(false);

  const [isInsurance, setIsInsurance] = useState(false);

  // 服務廠選項
  const [regionOptions, setRegionOptions] = useState([]);
  const [serviceOptions, setServiceOptions] = useState({});

  // const regionOptions = [
  //   { label: '台北市', value: 'taipei' },
  //   { label: '新北市', value: 'new-taipei' },
  // ];

  // const serviceOptions = {
  //   taipei: [
  //     { label: 'LEXUS南港廠', value: 'taipei-nangang' },
  //     { label: 'LEXUS內湖廠', value: 'taipei-neihu' },
  //   ],
  //   'new-taipei': [
  //     { label: 'LEXUS淡水廠', value: 'new-taipei-banciao' },
  //     { label: 'LEXUS永和廠', value: 'new-taipei-xinzhuang' },
  //   ],
  // };

  const getServiceInfo = () => {
    setIsLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_BASE_URL}/booking/service_info?car_no=${carNo}&auth_token=${token}`
      )
      .then((res) => {
        if (res.status === 200) {
          const resData = res.data;
          if (resData.success) {
            const distinctCities = [
              ...new Set(resData.data.map((item) => item.CITY)),
            ];
            setRegionOptions(
              distinctCities.map((city) => ({
                label: city,
                value: city,
              }))
            );
            const serviceOptionsByCity = {};
            distinctCities.forEach((city) => {
              serviceOptionsByCity[city] = resData.data
                .filter((item) => item.CITY === city)
                .map((item) => ({
                  label: item.BRNHNM,
                  value: `${item.DLRCD}-${item.BRNHCD}`,
                  dealerCode: item.DLRCD,
                  branchCode: item.BRNHCD,
                  phone: item.TEL || '',
                }));
            });
            setServiceOptions(serviceOptionsByCity);
          } else {
            if (resData.error === 'LexusAuthError') {
              setIsError(true);
              setErrorMessage(tokenExpiredMessage);
            } else {
              throw new Error(`${resData.error} ${resData.message}`);
            }
          }
        } else {
          throw new Error(`${res.status} ${res.statusText}`);
        }
      })
      .catch((err) => {
        console.error('err', err);
        setIsError(true);
        setErrorMessage(fetchFailedMessage);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (token && carNo) {
      getServiceInfo();
    }
  }, [token, carNo]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === 'paymentMethod' && value === 'insurance') {
      setIsInsurance(true);
    } else {
      setIsInsurance(false);
    }
  };

  //Picker 的 onConfirm
  const handleRegionConfirm = (val) => {
    setFormData((prev) => ({
      ...prev,
      region: val,
      serviceType: '', // 重置服務廠
    }));
  };

  const pickerStyle = {
    '--adm-font-size-main': '16px',
    '--item-height': '50px',
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = '請輸入姓名';
    if (!formData.phone.trim()) newErrors.phone = '請輸入聯絡電話';
    if (!formData.serviceType) newErrors.serviceType = '請選擇據點';
    if (!formData.repairType) newErrors.repairType = '請選擇預約內容';
    if (!formData.bookingTitle.trim())
      newErrors.bookingTitle = '請輸入預約主旨';
    if (!formData.description.trim()) newErrors.description = '請輸入預約說明';
    if (!formData.paymentMethod && maintenanceType === 'spray')
      newErrors.paymentMethod = '請選擇付費方式';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      // 顯示失敗 Modal
      setModalType('fail');
      setIsResultModalVisible(true);
    } else {
      setErrors({});
      setIsLoading(true);
      axios
        .post(
          `${process.env.REACT_APP_BASE_URL}/booking/other?car_no=${carNo}&line_id=${lineId}&auth_token=${token}`,
          formData
        )
        .then((res) => {
          if (res.status === 200) {
            const resData = res.data;
            if (resData.success) {
              // 顯示成功 Modal
              setModalType('success');
              setSubmitDisabled(true);
              setIsResultModalVisible(true);
            } else {
              if (resData.error === 'LexusAuthError') {
                setIsError(true);
                setErrorMessage(tokenExpiredMessage);
                setAllowConfirmError(false);
              } else {
                setIsError(true);
                setErrorMessage(resData.message);
                setAllowConfirmError(true);
                throw new Error(`${resData.error} ${resData.message}`);
              }
            }
          } else {
            throw new Error(`${res.status} ${res.statusText}`);
          }
        })
        .catch((err) => {
          console.error('err', err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  return (
    <div className="booking-container">
      {isLoading && <Spin fullscreen />}
      <ErrorModal
        isVisible={isError}
        message={errorMessage}
        allowConfirm={allowConfirmError}
        onClose={() => {
          setIsError(false);
          setErrorMessage('');
          setAllowConfirmError(false);
        }}
      />
      <Header />
      <div className="form-container">
        <div className="form-section">
          <form onSubmit={handleSubmit}>
            <div className="form-content">
              <Flex vertical gap={4}>
                <Flex align="center" gap="small">
                  <img src={caricon} alt="Car icon" />
                  <div className="form-title">
                    {maintenanceType === 'spray' ? '板噴服務' : '一般維修'}
                  </div>
                </Flex>
                <div className="form-subtitle">
                  <span className="label">車號：</span>
                  <span className="value">{carNo}</span>
                </div>
              </Flex>
              <Divider />
              <InputField
                label="姓名"
                name="name"
                value={formData.name}
                onChange={handleChange}
                error={errors.name}
              />
              <InputField
                label="聯絡電話"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                error={errors.phone}
                type="tel"
              />

              <div className="form-group">
                <label>
                  所在地（聯絡您的據點）
                  {errors.serviceType && (
                    <span className="error-text">{errors.serviceType}</span>
                  )}
                </label>
                <Flex gap="middle">
                  <div
                    className="picker-trigger region-picker"
                    onClick={() => setRegionPickerVisible(true)}>
                    <span
                      className={`picker-placeholder ${
                        formData.region ? 'has-value' : ''
                      }`}>
                      {formData.region
                        ? regionOptions.find((r) => r.value === formData.region)
                            ?.label
                        : '地區'}
                    </span>
                    <DownFill className="down-icon" />
                    <CustomPicker
                      visible={regionPickerVisible}
                      onClose={() => setRegionPickerVisible(false)}
                      onConfirm={(val) => handleRegionConfirm(val)}
                      title="選擇地區"
                      columns={regionOptions}
                      defaultValue={formData.region}
                    />
                  </div>
                  <div
                    className={`picker-trigger service-picker ${
                      !formData.region ? 'disabled' : ''
                    }`}
                    onClick={() => {
                      if (formData.region) setServicePickerVisible(true);
                    }}>
                    <span
                      className={`picker-placeholder ${
                        formData.serviceType ? 'has-value' : ''
                      }`}>
                      {formData.serviceType
                        ? serviceOptions[formData.region]?.find(
                            (s) => s.value === formData.serviceType
                          )?.label
                        : '服務廠'}
                    </span>
                    <DownFill className="down-icon" />
                    <CustomPicker
                      visible={servicePickerVisible}
                      onClose={() => setServicePickerVisible(false)}
                      onConfirm={(val) =>
                        setFormData((prev) => ({ ...prev, serviceType: val }))
                      }
                      title="選擇服務廠"
                      columns={serviceOptions[formData.region] || []}
                      defaultValue={formData.serviceType}
                    />
                  </div>
                </Flex>
              </div>
              {/* <div className="form-group">
                <label>
                  預約內容
                  {errors.repairType && (
                    <span className="error-text">{errors.repairType}</span>
                  )}
                </label>
                <Radio.Group
                  className="custom-radio-group"
                  value={formData.repairType}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      repairType: e.target.value,
                    }));
                    setErrors((prev) => ({
                      ...prev,
                      repairType: '',
                    }));
                  }}>
                  <Flex gap="small" align="center">
                    20250509 「召修」選項依使用者需求直接移除，並預設固定為選擇「其他維修」
                    <Radio value="召修">召修</Radio>
                    <Radio value="其他維修">其他維修</Radio>
                  </Flex>
                </Radio.Group>
              </div> */}
              <InputField
                label="預約主旨"
                name="bookingTitle"
                value={formData.bookingTitle}
                onChange={handleChange}
                error={errors.bookingTitle}
                disabled={maintenanceType === 'spray'}
              />
              <div className="form-group">
                <label>
                  預約說明（限60字）{' '}
                  {errors.description && (
                    <span className="error-text">{errors.description}</span>
                  )}
                </label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                />
              </div>
              {maintenanceType === 'spray' && (
                <div className="form-group">
                  <label>
                    付費方式
                    {errors.paymentMethod && (
                      <span className="error-text">{errors.paymentMethod}</span>
                    )}
                  </label>
                  <select
                    name="paymentMethod"
                    value={formData.paymentMethod}
                    onChange={handleChange}>
                    <option value="">-- 請選擇付費方式 --</option>
                    <option value="self">自費</option>
                    <option value="insurance">出險</option>
                  </select>
                </div>
              )}
            </div>
          </form>
        </div>
      </div>

      <div className="submit-container">
        <div className="submit-wrapper">
          <button
            onClick={handleSubmit}
            className="submit-button"
            disabled={submitDisabled}>
            確認預約
          </button>
          <ResultModal
            isVisible={isResultModalVisible}
            onClose={() => setIsResultModalVisible(false)}
            type={modalType}
            allowConfirm={true}
            isInsurance={isInsurance}
          />
        </div>
      </div>
    </div>
  );
};

export default BookingOther;
